import React from 'react';

import { CHECKMATE_MEMBERSHIP_URL } from 'shared/constants';
import { useRouteChangeHandler } from 'shared/hooks';

import DropdownMenu from './AboutUsMenu';
import ServicesMenu from './ServicesMenu';

type AppHeaderItemProps = {
  title: string;
  to?: string;
  target?: string;
  showNewBadge?: boolean;
  gaLabel?: string;
  subMenu?:
    | {
        title: string;
        to: string;
        target?: string;
        gaLabel?: string;
      }[]
    | 'services';
  memberRole: string;
};

const AppHeaderItem = ({ title, to, target, subMenu, showNewBadge, gaLabel, memberRole }: AppHeaderItemProps) => {
  const active = to ? window.location.pathname.startsWith(to) : false;
  const { handleRouteChange } = useRouteChangeHandler();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    window.dataLayer?.push({
      event: 'click_menu',
      menu: gaLabel ?? title,
      section: 'GNB',
    });

    if (target === '_blank') {
      window.open(to, '_blank');
      return;
    }

    if (to === '/membership') {
      if (memberRole === 'ROLE_TESTER') {
        handleRouteChange('/membership');
        return;
      }

      window.open(CHECKMATE_MEMBERSHIP_URL, '_blank');
      return;
    }

    if (to) {
      handleRouteChange(to);
    }
  };

  return (
    <ul>
      {subMenu === 'services' ? (
        <ServicesMenu />
      ) : subMenu ? (
        <DropdownMenu title={title} gaLabel={gaLabel} subMenu={subMenu} />
      ) : (
        <li className="relative flex cursor-pointer items-center rounded-lg px-3 py-[6px] text-b3 font-semibold hover:bg-[#F6F6F6]">
          <a
            href={to}
            onClick={handleClick}
            aria-current={active ? 'page' : undefined}
            className="flex items-baseline gap-1"
          >
            <span>{title}</span>
            {showNewBadge && (
              <span className="text-[12px] font-semibold leading-[1.5] tracking-[-0.264px] text-primary">NEW</span>
            )}
          </a>
        </li>
      )}
    </ul>
  );
};

export default AppHeaderItem;
